import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { API } from 'aws-amplify';
import { FilterMatchesPage } from 'src/app/lobbypage/filter-matches/filter-matches.page';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-pickem-lobbypage',
  templateUrl: './pickem-lobbypage.page.html',
  styleUrls: ['./pickem-lobbypage.page.scss'],
})
export class PickemLobbypagePage implements OnInit {

  public env = environment;
  language: string;
  match: string = "cricket";
  Namma11CupLogo = '/mobile/logos/appcuplogo.png';
  flag: boolean;
  flag2: boolean;
  filterArray: any[] = [];
  matchData: any;
  getmatchInformation: any;
  selectedFilter: any[] = [];
  notificationsUnread: any;
  cacheCleartimestamp : number = new Date().getTime();
  ionViewWillEnterSubject: Subject<void> = new Subject<void>();
  fromTeam: any;
  myMatchId: any;

  constructor(  public modelCtrl: ModalController,  private translate: TranslateService,
    private router: Router, private activatedRoute: ActivatedRoute) { }

  ionViewWillEnter() {
    this.cacheCleartimestamp  = new Date().getTime();
    this.ionViewWillEnterSubject.next();
      this.language = localStorage.getItem("language")
      if (this.language === 'en') {
        this.translate.use('en');
      }
      else if (this.language === 'hn') {
        this.translate.use('hn');
      }
      else if (this.language === 'kn') {
        this.translate.use('kn');
      }
      console.log("ionViewWillEnter");
      this.segmentChanged();
      this.getNotificationsUnreadCount();
    }   
  ngOnInit() {

    this.activatedRoute.params.subscribe((data)=>{
      this.fromTeam = data.fromTeam;
      this.myMatchId = data.deepLinkMatchId;
      
    });
    // this.segmentChanged();
    // this.getNotificationsUnreadCount();
  }
  // openNotificationsPage(event) {
  //   event.stopPropagation();
  //   if (this.notificationsUnread?.count) {
  //     this.getNotificationsUnreadCountMarkRead();
  //   }
  //   this.router.navigate(['notifications']);
  // }

  segmentChanged() {
    // if (this.match == "cricket") {
    //   this.flag = true;
    //   this.flag = false
    // } else {
    //   this.flag = false;
    //   this.flag2 = true;
    // }
    // console.log(this.match);
    //console.log(event);
  }
  GetChildData(data) {
    console.log(data);
    this.filterArray = data;
  }
  async openFilterMathes(ev: any) {
    console.log(ev);
    ev.stopPropagation();
    const model = await this.modelCtrl.create({
      component: FilterMatchesPage,
      showBackdrop: true,
      cssClass: 'modal-class1 ion-backdrop-fullwidth-modal',
      backdropDismiss: true,
      componentProps: { filterArray: this.filterArray, selectedArray: this.selectedFilter }
    });
    model.onDidDismiss()
      .then((data) => {
        // this.matchData = this.getmatchInformation['matches'];
        console.log(data.data);
        this.selectedFilter = data.data ? data.data.length ? data.data : [] : this.selectedFilter;
      });
    await model.present();
  }
  openNotificationsPage(event) {
    event.stopPropagation();
    if (this.notificationsUnread?.count) {
      this.getNotificationsUnreadCountMarkRead();
    }
    this.router.navigate(['notifications']);
  }

  getNotificationsUnreadCount() {
    const apiName = 'profile';
    const path = "/profiles/notifications/unread-count";
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {
        //startKey: 10
      },
    };
    API.get(apiName, path, myInit).then((data) => {
      this.notificationsUnread = data.data.data;
      console.log(this.notificationsUnread);
    }).catch((error) => {
      console.log(error);
    });
  }

  getNotificationsUnreadCountMarkRead() {
    console.log("notificationsMarkRead");
    const apiName = 'profile';
    const path = "/profiles/notifications/mark-read";
    const myInit = {
      headers: {},
      response: true,
      body: {},
    };
    API.post(apiName, path, myInit).then((data) => {
      console.log(data);
      let unread = data.data;
      console.log("MarkRead", unread);
    }).catch((error) => {
      console.log(error);
    });
  }

}
